import { useRef } from 'react'
import { BaseEditorImmagine } from 'images'
import { BaseButtons } from 'inputs'
import { BaseGridLayout } from 'layout'
import { parseDataUrlBase64 } from 'utils'
import { BasePopoverConfermaOperazione } from 'feedback'

export default function ModificaBinarioImmagineEditor(props) {
  const {
    immagineCorrente,
    chiudiModificaBinario,
    useGestioneFile,
    forzaRenderThumbnails,
    dimensioni,
  } = props

  const editorRef = useRef()

  const {
    uploadFile,
    ScatolaMessaggi,
    inAttesaDelServer,
  } = useGestioneFile()

  async function salvaBinarioImmagine() {
    const { mimetype, base64 } = parseDataUrlBase64(editorRef.current.getImage())
    let data = { ...immagineCorrente, mimetype, base64 }
    delete data.src
    delete data.tags

    const { ok } = await uploadFile(null, data)
    if (ok) {
      chiudiModificaBinario()
      forzaRenderThumbnails()
    }
  }

  return (
    <BaseGridLayout justifyCenter disposizioneRighe={[1, 2, 1]}>
      <BaseEditorImmagine
        editorRef={editorRef}
        modelli={MODELLI}
        getModelloConId={getModelloConId}
        sfondoSrc={immagineCorrente.src.fullSize}
        // sfondoSrc='http://local.incloudteam.com:3000/imgTest.jpg' // SOLO PER TESTARE IN LOCALHOST, PER LA TAINTED CANVAS 
        mimetypeImg={immagineCorrente.mimetype}
        style={{ ...dimensioni }}
        abilitaColori
      />

      <BasePopoverConfermaOperazione
        messaggio="L'immagine modificata sovrascriverà quella attuale. La versione originale rimarrà inalterata. Confermare?"
        onConferma={salvaBinarioImmagine}
      >
        <BaseButtons.Salva
          testo='Salva immagine'
          inAttesa={inAttesaDelServer}
          submit={false}
        />
      </BasePopoverConfermaOperazione>
      <BaseButtons.AnnullaModifiche
        color='default'
        onClick={() => chiudiModificaBinario()}
      />
      {ScatolaMessaggi}
    </BaseGridLayout>
  )
}



const MODELLI = [
  {
    categoria: 'oggetto',
    id: 'cerchio',
    nome: 'cerchio',
    tipo: 'shape',
    img: 'cerchio.png',
    larghezza: 50,
    altezza: 50
  },
  {
    categoria: 'oggetto',
    id: 'rettangolo',
    nome: 'rettangolo',
    tipo: 'shape',
    img: 'rettangolo.png',
    larghezza: 50,
    altezza: 100
  },
  {
    categoria: 'oggetto',
    id: 'freccia',
    nome: 'Freccia',
    tipo: 'svg',
    img: 'freccia.svg',
    larghezza: 140,
    altezza: 120
  },
  {
    categoria: 'testo',
    id: 'testo',
    nome: 'casella di testo',
    tipo: 'text',
    img: 'testo.png',
    larghezza: 200,
    altezza: 200
  },
].map(modello => ({
  ...modello,
  img: './static/img/schizzo-campagna/' + modello.img
}))

function getModelloConId(idModello) {
  return MODELLI.find(modello => modello.id === idModello)
}